import type { Theme } from '@mui/material';

// Shared styling configuration for referral strategy dropdowns
// Styled to match the sleek "naked" variant used in WaitingPeriodField and other line item dropdowns

export const REFERRAL_STRATEGY_DROPDOWN_STYLES = {
  select: (theme: Theme) => ({
    marginLeft: 0,
    '& .MuiOutlinedInput-root': {
      border: 'none',
      background: theme.palette.primary.dropdownBg,
      padding: 0,
      '&:hover': {
        border: 'none',
      },
      '&.Mui-focused': {
        border: 'none',
      },
    },
    '& .MuiSelect-select': {
      minHeight: 'auto',
      height: 'auto',
      width: 'auto',
      fontSize: '0.875rem',
      padding: '0px 10px 0px 0px',
      border: 'none',
      background: theme.palette.primary.dropdownBg,
      justifyContent: 'flex-end',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
  }),
  menu: {
    '& .MuiPaper-root': {
      minWidth: '12rem',
    },
  },
} as const;

